import React from "react";
import { Link } from "react-router-dom";

const Logo = () => (
  <Link to="/" className="flex items-center gap-2 sm:gap-3 min-w-0 shrink group" aria-label="TimerStore Startseite">
    <img
      src="/logo-icon.png"
      alt="TimerStore Sanduhr"
      className="h-10 sm:h-12 w-auto shrink-0 transition-transform duration-500 group-hover:scale-105"
    />
    <img
      src="/logo-text.png"
      alt="TimerStore"
      className="h-6 sm:h-8 w-auto min-w-0 max-w-[120px] min-[480px]:max-w-none object-contain object-left"
    />
  </Link>
);

export default Logo;
